import { inject, Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import posthog from 'posthog-js';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PosthogService {
  private authService = inject(AuthService);
  private initialized = false;

  async initializeForUser(): Promise<void> {
    if (this.initialized) return;

    this.authService.isAuthenticated().then(async isAuthenticated => {
      if (!isAuthenticated) return;
      const user = await this.authService.currentUserAttributes();
      if (!user) return;

      posthog.init(environment.POSTHOG_KEY, {
        api_host: environment.POSTHOG_HOST,
        person_profiles: 'identified_only'
      });

      posthog.identify(user.sub, {
        email: user.email,
        firstname: user.name,
        lastname: user.family_name
      });

      this.initialized = true;

    })


  }

  capture(event: string, properties?: Record<string, any>): void {
    if (this.initialized) {
      posthog.capture(event, properties);
    }
  }

}
